import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

/** Both systems' quotas for a Ranger survey: { quotas, systems, loading, error, reload }. */
const useSurveyQuotas = (surveyId) => {
  const [state, setState] = useState({ quotas: [], systems: {}, loading: true, error: null });

  const reload = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const { data } = await api.get(`/surveys/${surveyId}/quotas/`);
      setState({ quotas: data.quotas, systems: data.systems, loading: false, error: null });
    } catch {
      setState({ quotas: [], systems: {}, loading: false, error: "Couldn't load this survey's quotas." });
    }
  }, [surveyId]);

  useEffect(() => { reload(); }, [reload]);

  return { ...state, reload };
};

export default useSurveyQuotas;
